<template>
  <div
    :class="{
      [$style.inputField]: true,
      [$style.flexDisplay] : config.style && config.style.flexDisplay,
    }"
  >
    <span
      :class="{
        [$style.boldLabel] : config.style && config.style.boldLabel,
      }"
    >{{ config.confirmationText }}</span>
    <div :class="$style.inputContainer">
      <InputValidator
        :class="{
          [$style.confirmationInput]: true,
          [$style.confirmationInputWithError]: v2Errors.items.length,
          [$style.inputSpacing] : config.style && config.style.inputSpacing,
        }"
        :config="{
          autocomplete: config.autocomplete || 'on',
          'data-lpignore': true,
          disabled: config.disabled,
          errorStyleExceptions: $style.validationError,
          name: config.name,
          validate: config.validationRule,
          value: defaultValue,
          readonly: config.readonly,
          type: config.type || 'text'
        }"
        @InputValidatorModel="handleValueChange"
      />
    </div>
  </div>
</template>

<script>
import InputValidator from 'components/FormValidation/InputValidator.vue';

export default {
  name: 'ConfirmationInput',

  components: {
    InputValidator,
  },

  inject: ['$validator'],

  props: {
    config: {
      type: Object,
      required: true,
    },
    defaultValue: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.$validator.localize('en', {
      custom: {
        [this.config.name]: {
          between: this.config.betweenCustomMessage,
          email: this.config.emailCustomMessage,
          is: this.config.isCustomMessage,
          max_value: this.config.maxCustomMessage,
          min_value: this.config.minCustomMessage,
          numeric: this.config.numericCustomMessage,
          required: this.config.requiredCustomMessage,
        },
      },
    });
  },

  methods: {
    handleValueChange(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style module>
@value (red, orange) from '~css/colors.css';
@value (panelSpeedSm, panelTimingFunction) from '~css/transitions.css';

.boldLabel {
  display: block;
  font-weight: 600;
}

.flexDisplay {
  display: flex;
}

.inputField {
  margin-top: 20px;
  min-height: 85px;
}

.inputContainer {
  display: inline-block;
  margin-bottom: 30px;
  position: relative;
}

.confirmationInput {
  margin: 0 5px;
  text-align: center;
  transition: margin-bottom panelSpeedSm panelTimingFunction;
  width: 60px;
}

.inputSpacing {
  margin-left: -2px;
  margin-top: 10px;
  width: 400px;
}

.inputContainer .confirmationInput input {
  text-align: left;
}

.inputContainer .validationError {
  float: right;
  top: 105%;
  white-space: nowrap;
}
</style>
